import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "react-grid-system";

class SpecialMessage extends React.Component {
  static contextTypes = {
    copy: PropTypes.object,
  };
  render() {
    const copy = this.context.copy.get("SpecialMessage");
    return (
      <div
        className="bg-lbg no-gutter flex items-center"
        style={{ minHeight: "40px" }}
      >
        <Container className="w-100">
          <Row>
            <Col className="center py1">
              <a
                className="line-height-3 color-navy"
                target="_blank"
                rel="noopener noreferrer"
              >
                {window.innerWidth >= 900
                  ? copy && copy.messageDesktop
                  : copy && copy.messageMobile}
              </a>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default SpecialMessage;



// WEBPACK FOOTER //
// ./src/Home/SpecialMessage.js